import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.666 13.75L18.3327 15.4167L16.666 17.0833",
      stroke: "#522BD6",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.666 2.91675L18.3327 4.58341L16.666 6.25008",
      stroke: "#522BD6",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.3333 4.58325H15.4167C12.4251 4.58325 10 7.00838 10 9.99992C10 12.9915 12.4251 15.4166 15.4167 15.4166H18.3333",
      stroke: "#522BD6",
      "stroke-width": "1.25",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.66602 15.4166H4.58268C7.57422 15.4166 9.99935 12.9915 9.99935 9.99992C9.99935 7.00838 7.57422 4.58325 4.58268 4.58325H1.66602",
      stroke: "#522BD6",
      "stroke-width": "1.25",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }